import { cn } from "@/lib/utils"

export type StepperProps = {
	steps: number
	currentStep: number
	className?: string
}

export function Stepper({ steps, currentStep, className }: StepperProps) {
	return (
		<div className={cn("flex items-center w-full gap-2", className)}>
			{Array.from({ length: steps }, (_, index) => (
				<div key={index + 1} className="flex-1 flex items-center">
					<div
						className={cn(
							"h-0.5 flex-1 rounded",
							index <= currentStep - 1 ? "bg-primary" : "bg-gray-100"
						)}
					/>
				</div>
			))}
		</div>
	)
}
